import { Lightbulb, ListChecks, Plus } from 'lucide-react';
import { EmptyState } from '@/shared/components/empty-state';
import { useTranslation } from '@/shared/i18n/use-translation';
import { Button } from '@/shared/ui/button/button';
import type { TasksTab } from '../schemas/tasks-tab';

type TasksEmptyProps = {
  readonly tab: TasksTab;
  readonly onAdd: () => void;
};

export function TasksEmpty({ tab, onAdd }: TasksEmptyProps) {
  const { t } = useTranslation();
  if (tab === 'closed') {
    return (
      <p className="py-10 text-center text-sm text-muted-foreground">{t('You have not closed any yet.')}</p>
    );
  }
  const recommendations = tab === 'recommendation';
  return (
    <EmptyState
      icon={recommendations ? Lightbulb : ListChecks}
      title={recommendations ? t('No recommendations') : t('Nothing to do')}
      description={
        recommendations
          ? t('Keep advice you want to follow: rotate the water every 6 months, learn first aid…')
          : t('Write down actions with a date, or checks that repeat every so often.')
      }
      action={
        <Button onClick={onAdd}>
          <Plus /> {t('Add')}
        </Button>
      }
    />
  );
}
